import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import Button from "../Helpers/Button/Button";
import trans from "../../utils";

export default function UISignature({
	item,
	setDroppedItems,
	preview,
	addData,
	setSubmitData,
	submitData,
	readOnly,
}) {
	const [value, setValue] = useState("");

	const currentValue = addData
		? (submitData?.find((i) => i.key === item.key)?.value ?? "")
		: (item?.value ?? value ?? "");
	const signatureRef = useRef(currentValue);
	useEffect(() => {
		if (submitData?.length > 0) {
			const sign = submitData?.find((i) => i.name === "Signature");
			setValue(sign);
		}
	}, [submitData]);

	const handleClear = () => {
		signatureRef.current?.clear?.();
		setValue(null);
		if (addData) {
			setSubmitData((prev) =>
				prev ? prev.filter((i) => i.key !== item.key) : [],
			);
		}
	};

	const handleGetImage = () => {
		if (signatureRef.current && !signatureRef.current.isEmpty() && addData) {
			const dataURL = signatureRef.current.toDataURL("image/png");
			setSubmitData((prev) => {
				// Remove existing item with same key if you want to replace it
				const filtered = prev?.filter((i) => i.key !== item.key) || [];
				return [
					...filtered,
					{
						key: item.key,
						name: item.name,
						title: item.title,
						value: dataURL,
					},
				];
			});
			console.log("Signature as base64 PNG:", dataURL);
		} else {
		}
	};
	const { border, ...divStylesWithoutBorder } = item?.css || {};

	const validate = addData
		? item?.required?.value && currentValue === ""
		: item?.required?.value && currentValue === "";

	return (
		<div style={item?.css}>
			<label
				style={{
					color: item?.css?.color,
					fontFamily: item?.css?.fontFamily,
					fontSize: item?.css?.fontSize,
					fontWeight: item?.css?.fontWeight,
				}}
				htmlFor={item?.key || "signature"}
				className="form-label d-block"
			>
				<div className="d-flex align-items-center">
					{item?.title}
					{item?.required?.value && value === "" && (
						<div className="text-danger ms-2">*</div>
					)}
				</div>
			</label>
			<div>
				<div className="d-flex align-items-end">
					<SignatureCanvas
						ref={signatureRef}
						penColor="green"
						canvasProps={{
							width: item?.css?.width ? item?.css?.width : 400,
							height: 200,
							className: "sigCanvas",
							style: { border: "1px solid #ccc" },
						}}
						onEnd={handleGetImage}
					/>
					{value?.value && (
						<Button type="default" onClick={handleClear} className="mx-2">
							{trans("Clear")}
						</Button>
					)}
				</div>
				{((addData && value) || item?.value) && (
					<img
						src={value?.value || item?.value}
						alt="file"
						style={{
							width: "150px",
							height: "150px",
							borderRadius: "8px",
							display: "block",
						}}
					/>
				)}
				{preview !== true ? (
					<>
						{validate && (
							<div className="text-danger mt-1">
								{trans(item?.required?.validationMessage)}
							</div>
						)}
					</>
				) : (
					""
				)}
			</div>

			{/**<div style={{ marginTop: 10 }}>
				<button onClick={handleClear}>Clear</button>
				<button onClick={handleGetImage} style={{ marginLeft: 10 }}>
					Get Image
				</button>
			</div>**/}
		</div>
	);
}
